import { render, staticRenderFns } from "./BCSelCallMessageList.vue?vue&type=template&id=02afc61e&scoped=true"
import script from "./BCSelCallMessageList.vue?vue&type=script&lang=js"
export * from "./BCSelCallMessageList.vue?vue&type=script&lang=js"
import style0 from "./BCSelCallMessageList.vue?vue&type=style&index=0&id=02afc61e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02afc61e",
  null
  
)

export default component.exports